module.exports = __webpack_public_path__ + "img/yellow-btn.dad9ef47.svg";